import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Checkbox, TextField, Typography } from "@material-ui/core";
import { ControlledSelect } from "./controlledSelect";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import { camelCaseToTitle } from "../utils/camelCaseToTitle";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function AddMetadataDialog({
    open,
    handleClose,
    data,
    onChange,
    handleFormSubmit,
    countryOption,
    collection,
}) {
    const activeOption = [
        {
            value: false,
            label: "No",
        },
        {
            value: true,
            label: "Yes",
        },
    ];
    const classes = useStyles();

    return (
        <>
            <div>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle id="metadata-dialog-title">{`Add ${camelCaseToTitle(collection)} Metadata`}</DialogTitle>
                    <DialogContent>
                        <Typography variant="subtitle1" component="p">
                            Please fill out the information below and submit.
                        </Typography>
                        <div
                            style={{ marginBottom: "5px", display: "block" }}
                        ></div>
                        <form onSubmit={handleFormSubmit}>
                            <TextField
                                required={true}
                                type="text"
                                id="name"
                                value={data.name.value}
                                onChange={(e) => onChange(e)}
                                placeholder={`Enter ${camelCaseToTitle(collection)} Field Name`}
                                label={camelCaseToTitle(collection)}
                                variant="outlined"
                                margin="dense"
                                fullWidth
                            />
                            <FormControl className={classes.formControl}>
                                <InputLabel id="countries-mutiple-checkbox-label">
                                    Countries
                                </InputLabel>
                                <Select
                                    labelId="countries-mutiple-checkbox-label"
                                    id="countries-mutiple-checkbox"
                                    multiple
                                    value={data.countries.value}
                                    onChange={(e) => onChange(e)}
                                    name="countries"
                                    input={<Input />}
                                    renderValue={(selected) =>
                                        selected.length === countryOption.length
                                            ? "ALL"
                                            : selected.join(", ")
                                    }
                                    MenuProps={MenuProps}
                                    required={true}
                                >
                                    {countryOption.map((country, index) => (
                                        <MenuItem
                                            key={`${index}-${country.value}`}
                                            value={country.value}
                                        >
                                            <Checkbox
                                                checked={
                                                    data.countries.value.indexOf(
                                                        country.value,
                                                    ) > -1
                                                }
                                            />
                                            <ListItemText
                                                primary={country.label}
                                            />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <ControlledSelect
                                id="isActive"
                                label="Is Active*"
                                value={data.isActive.value}
                                options={activeOption}
                                onChange={(e) => onChange(e)}
                                hasError={data.isActive.hasError}
                                includeAllFlag="false"
                            />
                            <DialogActions>
                                <Button
                                    onClick={handleClose}
                                    color="secondary"
                                    variant="outlined"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}

export default AddMetadataDialog;
